import { html, CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './tufts-image-compare.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { SlotNGController } from '../../controllers/slot-ng-controller';

@customElement('tufts-image-compare')
export class TuftsImageCompare extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  ngSlot = new SlotNGController(this);

  @property({ type: String, reflect: true, attribute: 'initial-exposure' })
  initialExposure = '50';

  private clippingSlider: HTMLInputElement | null = null;
  private animationFrame: number | null = null;

  private handleInput = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const newValue = target.value;
    const imageCompareWrapper = this.shadowRoot?.querySelector(
      '.image-compare'
    ) as HTMLDivElement;

    if (this.animationFrame) cancelAnimationFrame(this.animationFrame);

    // Store an animation frame so we can keep track of scheduled
    // repaints and cancel old repaints that haven't happened yet
    this.animationFrame = requestAnimationFrame(() => {
      imageCompareWrapper.style.setProperty('--exposure', `${newValue}%`);
    });
  };

  firstUpdated() {
    const imageCompareWrapper = this.shadowRoot?.querySelector(
      '.image-compare'
    ) as HTMLDivElement;
    if (!imageCompareWrapper) {
      return;
    }

    imageCompareWrapper.style.setProperty(
      '--exposure',
      `${this.initialExposure}%`
    );

    this.clippingSlider =
      this.shadowRoot?.querySelector('.image-compare-input') ?? null;

    // Check if clippingSlider is not null before adding event listener
    if (this.clippingSlider) {
      this.clippingSlider.addEventListener('input', this.handleInput);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.clippingSlider) {
      this.clippingSlider.removeEventListener('input', this.handleInput);
    }
  }

  render() {
    return html`
      <div class="image-compare-wrapper">
        <div class="image-compare">
          ${this.ngSlot.renderInShadow()}
          <span class="divider"></span>
          <label class="image-compare-label">
            <span class="visually-hidden"
              >Select what percentage of the bottom image to show</span
            >
            <input
              type="range"
              min="0"
              max="100"
              value="${this.initialExposure}"
              class="image-compare-input"
            />
          </label>
        </div>
        ${this.ngSlot.conditionalNGSlot('caption')}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-image-compare': TuftsImageCompare;
  }
}
